let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("4UPrd"), load("851pc")]).then(() => parcelRequire('4b0nc'));